import React from 'react'
import {Lang} from 'yougile-lang'
import {Time, Util} from 'yougile-util'
import {DataObjectId, getMessageAssignIds} from 'yougile-model'
import {Sync} from '@client/sync'
import {ChatSystemMessage} from '@components/common/base/chat-system-message'
import {ReferencedUser} from '@components/right-panel/chat/chat-messages/message/referenced-user'
import {SystemMessageProps} from '@components/right-panel/chat/chat-messages/message/types'

interface MessageContentProps {
  assigned: DataObjectId[]
  assignedBy?: DataObjectId
  guestId?: DataObjectId
}

const MessageContent = ({
  assigned,
  assignedBy,
  guestId
}: MessageContentProps) => {
  const content: React.ReactNode[] = [
    `${Lang.msg.chat.assignInfoPrefix(assigned.length)} `
  ]
  assigned.forEach((userId, i) => {
    if (i) {
      content.push(<React.Fragment key={i}>, </React.Fragment>)
    }
    content.push(
      <ReferencedUser key={userId} userId={userId} guestId={guestId} />
    )
  })
  content.push(
    <span key="message">
      {' '}
      {Lang.msg.chat.assignInfoInfix(assigned.length)}{' '}
    </span>
  )
  content.push(
    <ReferencedUser key="assigned-by" userId={assignedBy} guestId={guestId} />
  )
  return <>{content}</>
}

export const AssignmentSystemMessage = ({
  message,
  className,
  animateShow
}: SystemMessageProps) => {
  const box = Sync.getOrCurrent(message)
  const assigned = getMessageAssignIds(message)
    .map(uid => box.getUser(uid))
    .filter(Util.isDefined)
    .map(x => x.id)
  const assignedBy = message.properties.actionBy as DataObjectId
  const guestId = message.properties.guestId as DataObjectId

  return (
    <ChatSystemMessage
      type="info"
      layout="vertical"
      content={
        <MessageContent
          assigned={assigned}
          assignedBy={assignedBy}
          guestId={guestId}
        />
      }
      dateTime={Time.formatDateTime(message.timestamp)}
      className={className}
      animateShow={animateShow}
      timestamp={message.timestamp}
    />
  )
}
